export default {
  readers: [
    'CashflowReaders',
    'Admin'
  ],
  writers: [
    'CashflowWriter',
    'Admin'
  ]
}
